import 'select2';
import { SearchService } from './SearchService';

const select2Config = {
	width: 'element',
	minimumResultsForSearch: Infinity,
	theme: 'light',
};

export class FacetSelect<TFacets extends string, ISearchResult> {
	protected _className;
	protected _facetName;
	protected _searchService;
	protected _element: JQuery<HTMLElement>;
	protected _tabsElement: JQuery<HTMLElement> | null;

	public constructor(
		element: JQuery<HTMLElement>,
		searchService: SearchService<TFacets, ISearchResult>,
		facetName: TFacets,
		className: String,
	) {
		this._element = element;
		this._facetName = facetName;
		this._searchService = searchService;
		this._className = className;

		this._element.select2({
			...select2Config,
			width: 'element',
			selectionCssClass: this._className,
			dropdownCssClass: this._className,
		});

		this.render();

		this._element.on('change', () => {
			this.handleChange();
		});

		searchService.addResultsListener(() => this.render());
	}

	protected render() {
		const value =
			this._searchService.searchParams.facetsData &&
			this._facetName in this._searchService.searchParams.facetsData &&
			this._searchService.searchParams.facetsData[this._facetName] &&
			this._searchService.searchParams.facetsData[this._facetName].length
				? this._searchService.searchParams.facetsData[this._facetName]
				: '';

		if (value == 'all') {
			this._element.val(null).trigger('change');
			console.log('clicked all');
		} else {
			this._element.val(value).trigger('change');
		}
	}

	protected isActiveFilter(filterValue: string) {
		if (
			this._searchService.searchParams.facetsData &&
			this._facetName in this._searchService.searchParams.facetsData &&
			this._searchService.searchParams.facetsData[this._facetName].indexOf(filterValue) >= 0
		) {
			return true;
		}

		return false;
	}

	protected handleChange() {
		const facetValue = this._element.val();

		const newSearchParams = this._searchService.searchParams;
		if (!newSearchParams.facetsData) {
			newSearchParams.facetsData = {} as any;
		}

		if (facetValue) {
			newSearchParams.facetsData[this._facetName] =
				typeof facetValue === 'string' ? [facetValue] : (facetValue as string[]);
		} else {
			newSearchParams.facetsData[this._facetName] = [];
		}

		this._searchService.searchParams = newSearchParams;
	}
}



// WEBPACK FOOTER //
// ./scripts/algolia/FacetSelect.ts